import { Fragment } from 'react';

import { Amount } from '@/components/amount';
import { TableCell, TableFooter, TableRow } from '@/components/ui/table';

import type { TotalsModel } from './types';

/**
 * The lines table's footer: one label, then the figures separated by
 * slashes — "Net / Tax / Total  $200.00 / $0.00 / $200.00". Rendered as a
 * `<tfoot>` so it belongs to the table it sums.
 */
export function TotalsFooter({ label, totals, colSpan }: { label: string; totals: TotalsModel; colSpan: number }) {
  return (
    <TableFooter>
      <TableRow>
        <TableCell colSpan={colSpan} className="text-end text-sm">
          <span className="text-muted-foreground">{label}</span>{' '}
          {totals.amounts.map((amount, index) => (
            <Fragment key={index}>
              {index > 0 ? ' / ' : null}
              <Amount
                value={amount.value}
                currency={amount.currency}
                className={amount.emphasis ? 'font-bold' : undefined}
              />
            </Fragment>
          ))}
        </TableCell>
      </TableRow>
    </TableFooter>
  );
}
